<template>
  <div class="video-page">
    <my-breadcrumb :items="pagination"></my-breadcrumb>
    <div class="dashboard-page-container">
      <h4>{{youtube.name}}</h4>

      <div class="youtube-video-container mt-2 mb-5">
        <iframe
          width="560"
          height="315"
          :src="youtube.url.replace('watch?v=','embed/')"
          frameborder="0"
          allow="autoplay; encrypted-media"
          allowfullscreen
          class="youtube-video"
          v-if="youtube.url"
        >
        </iframe>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import * as types from "@/store/types";

export default {
  data() {
    return {
      pagination: [],
      youtube: {}
    };
  },
  computed: {
    ...mapGetters({
      isLoggedIn: types.IS_LOGGED_IN  
    })
  },
  watch: {
    $route: function(newVal) {
      this.getDetail();
    }
  },
  mounted() {
    if(this.isLoggedIn) {
      this.getDetail();
    } else {
      var link = "/login"
      if(this.$route.params.section) {
        link += "?section=" + this.$route.params.section
      }
      this.$router.push(link);
    }
  },
  methods: {
    ...mapActions({
      getContentDetail: types.GET_CONTENT_DETAIL
    }),
    getDetail() {
      this.getContentDetail(this.$route.params.id)
      .then(response => {
        this.youtube = response[0];
        this.pagination = [
          {
            text: this.youtube.level,
            url: '#'
          },
          {
            text: this.youtube.class + " "+ this.youtube.major ? this.youtube.class : "",
            url: '#'
          },
          {
            text: this.youtube.subject,
            url: '#'
          },
          {
            text: this.youtube.curriculum,
            url: '#'
          },
          {
            text: this.youtube.chapter,
            url: '#'
          },{
            text: this.youtube.section,
            url: '#'
          }
        ];
      }).catch(error => {
        this.showMessageBox(error, "Failed to get contents", "danger");
      })
    },
    showMessageBox(message, title, variant) {
      this.$bvModal.msgBoxOk(message, {
        title: title,
        size: 'sm',
        buttonSize: 'sm',
        okVariant: variant,
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        centered: true
      })
      .then(value => {
        this.temp = value
      })
      .catch(err => {
        this.temp = err;
      });
    }
  }
};
</script>

<style>
.youtube-video-container {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
}
.youtube-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
